import { i18n } from 'src/i18n';
import LocationService from 'src/modules/location/locationService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';
import locationListActions from '../list/locationListActions';

const prefix = 'LOCATION_FORM';

const locationFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: locationFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await LocationService.find(id);
      }

      dispatch({
        type: locationFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: locationFormActions.INIT_ERROR,
      });

      getHistory().push('/location');
    }
  },

  doCopy: (values) => async (dispatch) => {
    try {
      dispatch({
        type: locationFormActions.CREATE_STARTED,
      });

      await LocationService.create(values);

      dispatch({
        type: locationFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.location.create.success'),
      );

      dispatch(locationListActions.doCopyFetch());
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: locationFormActions.CREATE_ERROR,
      });
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: locationFormActions.CREATE_STARTED,
      });

      await LocationService.create(values);

      dispatch({
        type: locationFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.location.create.success'),
      );

      getHistory().push('/location');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: locationFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, _getState) => {
    try {
      dispatch({
        type: locationFormActions.UPDATE_STARTED,
      });

      await LocationService.update(id, values);

      dispatch({
        type: locationFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.location.update.success'),
      );

      // getHistory().push('/location');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: locationFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default locationFormActions;
